export default {"src":"/_next/static/media/SpineBack.de7674da.svg","height":91,"width":90,"blurWidth":0,"blurHeight":0};